export const serviceTypes = ["全部", "家电维修", "家政服务", "快递代收", "开锁换锁", "宠物照看", "管道疏通"];
export const serviceDistricts = ["全部", "槐树小区", "绿荫花园", "和平里", "幸福家园"];

export const serviceList = [
  {
    id: "s1",
    title: "家电维修·空调洗衣机上门检修",
    type: "家电维修",
    district: "槐树小区",
    date: "2026-10-09",
    views: 720,
    contactName: "维修张师傅",
    contactNote: "从业十五年的老维修，可上门检修空调、洗衣机、冰箱等，收费透明，先报价后维修。",
    image: "https://readdy.ai/api/search-image?query=Professional%20appliance%20repair%20technician%20with%20tool%20box%20fixing%20air%20conditioner%2C%20clean%20bright%20interior%2C%20blue%20overalls%2C%20friendly%20and%20trustworthy%20look&width=800&height=800&seq=service-s1&orientation=squarish",
    tags: ["家电", "上门", "老手艺"],
    content: [
      "张师傅在社区做了十五年维修，擅长空调加氟、清洗，洗衣机脱水异常、冰箱不制冷等常见问题。",
      "上门前先电话沟通故障情况，现场检测后明码报价，居民同意后再动手，绝无隐形消费。小毛病只收基础上门费。",
      "服务范围覆盖槐树小区及周边，工作日上午九点到晚上七点可预约。老年居民可享维修费九折。",
    ],
  },
  {
    id: "s2",
    title: "家政服务·日常保洁与深度擦窗",
    type: "家政服务",
    district: "绿荫花园",
    date: "2026-10-08",
    views: 980,
    contactName: "洁净家政服务队",
    contactNote: "提供日常保洁、开荒保洁、玻璃清洗、油烟机清理等，阿姨经验丰富，做事细心。",
    image: "https://readdy.ai/api/search-image?query=Home%20cleaning%20service%20worker%20wiping%20window%20with%20cloth%2C%20bright%20clean%20apartment%2C%20sunlight%2C%20fresh%20and%20tidy%20atmosphere&width=800&height=800&seq=service-s2&orientation=squarish",
    tags: ["保洁", "擦窗", "家政"],
    content: [
      "洁净家政由几位本地阿姨组成，主要在绿荫花园一带接单，做日常保洁与深度清洁。",
      "日常保洁按小时计费，深度保洁按房屋面积报价，擦窗、油烟机、卫生间除垢可单独预约。所有工具与清洁剂自带，环保无刺激气味。",
      "预约需提前一天，周末较为紧俏。做完不满意可免费返工一次。",
    ],
  },
  {
    id: "s3",
    title: "快递代收·小区门口便民代收点",
    type: "快递代收",
    district: "和平里",
    date: "2026-10-07",
    views: 1560,
    contactName: "和平里便利店",
    contactNote: "便利店内设代收点，白天上班不在家的邻居可代收快递，随到随取，安全省心。",
    image: "https://readdy.ai/api/search-image?query=Tidy%20neighborhood%20convenience%20store%20with%20parcel%20shelf%20full%20of%20packages%2C%20warm%20lighting%2C%20friendly%20shop%20interior%2C%20clean%20and%20organized&width=800&height=800&seq=service-s3&orientation=squarish",
    tags: ["代收", "便民", "快递"],
    content: [
      "和平里便利店提供快递代收服务，白天不在家的邻居可让快递员放在店里，下班顺路自取。",
      "代收免费，大件或贵重物品请提前电话说明。店内设有监控与专门货架，按楼栋分类摆放，找件方便。",
      "营业时间为每天早上七点到晚上十一点，全年无休。",
    ],
  },
  {
    id: "s4",
    title: "开锁换锁·24小时应急上门",
    type: "开锁换锁",
    district: "槐树小区",
    date: "2026-10-05",
    views: 640,
    contactName: "锁匠老周",
    contactNote: "正规备案锁匠，提供开锁、换锁芯、配钥匙服务，24小时应急，出勤快。",
    image: "https://readdy.ai/api/search-image?query=Locksmith%20hands%20installing%20a%20door%20lock%20with%20tools%2C%20close%20up%2C%20clean%20neutral%20background%2C%20professional%20and%20trustworthy&width=800&height=800&seq=service-s4&orientation=squarish",
    tags: ["开锁", "换锁", "应急"],
    content: [
      "老周是备案在册的正规锁匠，提供开锁、更换锁芯、配制钥匙等服务，夜间与节假日同样出勤。",
      "上门会先核对住户信息，开锁后不损坏门锁。更换锁芯提供多种型号可选，质保一年。",
      "有紧急情况可直接电话联系，通常在二十分钟内到达。",
    ],
  },
  {
    id: "s5",
    title: "宠物照看·出差代喂遛狗服务",
    type: "宠物照看",
    district: "幸福家园",
    date: "2026-10-03",
    views: 520,
    contactName: "爱宠的小雨",
    contactNote: "本人养猫养狗多年，提供上门喂食、遛狗、铲屎服务，可拍视频反馈，让主人放心。",
    image: "https://readdy.ai/api/search-image?query=Young%20woman%20pet%20sitter%20playing%20with%20a%20happy%20dog%20in%20a%20cozy%20home%2C%20warm%20light%2C%20friendly%20caring%20atmosphere&width=800&height=800&seq=service-s5&orientation=squarish",
    tags: ["宠物", "代喂", "遛狗"],
    content: [
      "出差、旅行时最放心不下家里的毛孩子？小雨提供上门宠物照看服务，可代喂食、加水、铲屎、陪玩，也提供遛狗。",
      "每次服务都会拍摄小视频和照片发给主人，全程透明。如宠物有特殊饮食或用药需求，请提前告知。",
      "服务范围在幸福家园周边，单次与包周均可，节假日需提前预约。",
    ],
  },
  {
    id: "s6",
    title: "管道疏通·厨房卫生间下水道清理",
    type: "管道疏通",
    district: "和平里",
    date: "2026-10-01",
    views: 430,
    contactName: "疏通老王",
    contactNote: "专治下水道堵塞、马桶返味，携带专业设备，随叫随到，疏通不通不收费。",
    image: "https://readdy.ai/api/search-image?query=Plumber%20with%20drain%20cleaning%20equipment%20working%20in%20a%20clean%20kitchen%2C%20professional%20tools%2C%20bright%20interior%2C%20trustworthy%20look&width=800&height=800&seq=service-s6&orientation=squarish",
    tags: ["疏通", "管道", "应急"],
    content: [
      "厨房水槽、卫生间地漏、马桶堵塞都可以找老王。携带电动疏通机与高压设备，多数情况当场解决。",
      "上门先查看堵塞情况并报价，居民认可后再施工，疏通不通不收费。施工后会清理现场，保持干净。",
      "如遇主管道堵塞等复杂情况，会提前说明并协助联系物业。",
    ],
  },
];